// Trove-internal email domains. Gates "Trove only" features (see useIsTroveUser / TroveOnly) and
// internal-only links such as the Bitbucket pipeline run on the theme page.
// Both are intentional: `@trove.co` is the standard staff domain; `@trove.com` was requested by
// product. Do NOT remove `@trove.com` as an apparent typo — it appears nowhere else in the repo by
// design. (Safe regardless of who owns the domain: the email comes from an authenticated,
// Trove-provisioned identity, so it can't be self-registered to gain internal status.)
const INTERNAL_EMAIL_DOMAINS = ['@trove.co', '@trove.com'];

/**
 * True when the email belongs to a Trove-internal user (the trove.co / trove.com domains).
 * Case-insensitive;
 * a missing/empty email is treated as external (false) — fail closed, so internal-only UI is
 * hidden unless the user is provably internal.
 */
export const isTroveInternalEmail = (email: string | undefined): boolean => {
  if (!email) {
    return false;
  }
  const normalized = email.trim().toLowerCase();
  return INTERNAL_EMAIL_DOMAINS.some(domain => normalized.endsWith(domain));
};
